import {
  DiscountStatusCode,
  NewPartnerDiscountResponse,
} from '../interfaces/Partners/NewPartnerDiscount'

export const getSortedMatchingDiscountArrays = (discounts: NewPartnerDiscountResponse[]) => {
  const sortedActiveDiscounts: NewPartnerDiscountResponse[] = []
  const sortedSuggestedDiscounts: NewPartnerDiscountResponse[] = []

  const suggestedDiscounts = discounts.filter(
    (discount) => discount.statuss_kods === DiscountStatusCode.Piedāvāta
  )
  const activeDiscounts = discounts.filter(
    (discount) => discount.statuss_kods === DiscountStatusCode.Aktīva
  )

  activeDiscounts.forEach((activeDiscount) => {
    const matchingSuggestedDiscount = suggestedDiscounts.find(
      (suggestedDiscount) => suggestedDiscount.aizstājamā_atlaide_id === activeDiscount.id
    )
    sortedSuggestedDiscounts.push(matchingSuggestedDiscount || ({} as NewPartnerDiscountResponse))
    sortedActiveDiscounts.push(activeDiscount)
  })

  // Case for suggested discount without active discount reference
  suggestedDiscounts.forEach((suggestedDiscount) => {
    if (suggestedDiscount.aizstājamā_atlaide_id === null) {
      sortedSuggestedDiscounts.push(suggestedDiscount)
      sortedActiveDiscounts.push({} as NewPartnerDiscountResponse)
    }
  })

  return {
    sortedActiveDiscounts,
    sortedSuggestedDiscounts,
  }
}
